import PromoSingle from "../../promotion/PromoSingle";

const PromoCustomerDetail = ({ backPath = "/customer/promotions" }) => {
  return ( 
    <div className="mb-4 pb-4"> 
      <PromoSingle 
        backbtn={backPath}
      />
    </div>
  );
};

export default PromoCustomerDetail;
